module.exports = __webpack_public_path__ + "img/dori_es_janos.8646d44e.png";